import { Location } from '@/stores/types/propertyValuation';

export function formatAddress(addr: Location): string {
  const street = addr.streetName || addr.street || addr.formattedAddress || '';
  const number = addr.streetNumber ? ` ${addr.streetNumber}` : '';
  const postalCity = addr.postalCode && addr.city ? `, ${addr.postalCode} ${addr.city}` : '';

  return `${street}${number}${postalCity}, Switzerland`;
}

export function splitFormattedAddress(formattedAddress?: string): Location {
  const [street, postalCity, _country] = formattedAddress?.split(',') || [];

  const streetName = street.split(' ').slice(0, -1).join(' ');
  const streetNumber = street.split(' ').slice(-1, street.length).join(' ');
  const { postalCode, city } = splitPostalCodeCity(postalCity || '');

  return {
    streetName,
    streetNumber,
    postalCode,
    city,
  };
}

function splitPostalCodeCity(postalCity: string): { postalCode?: string; city: string } {
  const postalCodeRegex = /^\d{4}/;
  const hasPostalCode = postalCodeRegex.test(postalCity?.trim() || '');
  if (hasPostalCode) {
    const [postalCodePart, ...cityPart] = postalCity?.trim().split(' ') || [];
    const postalCode = postalCodePart || '';
    const city = cityPart?.join(' ').trim() || '';
    return {
      postalCode,
      city,
    };
  }
  const city = postalCity?.trim() || '';
  return {
    city,
  };
}
